export default __webpack_public_path__ + "static/media/Section4Diagram1-A.12d56161.png";